import {
  BookOpenIcon,
  ClipboardCheckIcon,
  FileTextIcon,
  ListChecksIcon,
  RulerIcon,
  BadgeCheckIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  { icon: BookOpenIcon, title: '10 Complete Volumes', description: 'One polished workbook per grade, 1 through 10' },
  {
    icon: FileTextIcon,
    title: '600-Page Curriculum',
    description: 'Theory, worked examples, and practice for the whole year',
  },
  {
    icon: ListChecksIcon,
    title: 'Step-by-Step Practice',
    description: 'Guided and independent sets with built-in hints',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Assessments & Answer Keys',
    description: 'Diagnostics, quizzes, and term exams, all with keys',
  },
  { icon: RulerIcon, title: 'Hands-On Projects', description: 'Real-world tasks with grading rubrics in every grade' },
  { icon: BadgeCheckIcon, title: 'Common Core Aligned', description: 'Every unit tagged to CCSS-Math standards' },
]
